import type { MutationConfig } from "apps/visits/core/lib/react-query";
import { useMutation, useQueryClient } from "react-query";
import type { Order } from "../models";
import { useGetSlug } from "../store/use-config";
import { QUERY_KEY as GET_ORDER_QUERY_KEY } from "./get-order.query";
import { GroupActionsOrderingRepository } from "./group-actions-ordering.api";

const groupActionsOrderingRepository = new GroupActionsOrderingRepository();

type SelectTimeSlotOptions = {
  uuid: Order["uuid"];
  config?: MutationConfig<typeof groupActionsOrderingRepository.selectTimeSlot>;
};

export const useSelectTimeSlot = ({ uuid, config }: SelectTimeSlotOptions) => {
  const slug = useGetSlug();
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    mutationFn: (data) => groupActionsOrderingRepository.selectTimeSlot(data, uuid, slug),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_ORDER_QUERY_KEY] });
    },
  });
};
